<template>
  <div class="one-year-promotion-done">
    <dashboard-page :image-header-props="imageHeaderProps">
      <template v-slot:header>
        <div class="headline-container padding-top-ml flex-column flex-1">
          <div class="ri-large-body">התשלום עבר בהצלחה</div>
          <div class="ri-small-display">
            <div>איזה כיף </div>
            <div>שחסכת!</div>
          </div>
        </div>
        <div class="header-animation-container">
          <lottie-player src="/animations/payment-success.json" autoplay loop class="success-lottie"/>
        </div>
      </template>
      <template v-slot:dashboard>
        <div class="margin-ml">
          <property class="margin-bottom-xs" name="סוג מינוי" :value="'שנתי'"/>
          <div class="promotion-highlight margin-bottom-m">שנה נוספת במחיר מוזל!</div>
          <property class="margin-bottom-xs" name="סך הכל ששולם" :value="price"/>
          <property class="margin-bottom-m" name="תאריך לחיוב" :value="todayDate"/>
          <property v-if="paymentInfo && paymentInfo.usedExistingCard" class="margin-bottom-m" name="כרטיס אשראי שחויב" :value="displayCardMask"/>
          <property class="margin-bottom-xs" name="אימייל לשליחת קבלות" :value="activeMember.emailPiiValue"/>
          <div class="link" @click="redirectToPersonalInfo">עריכה</div>
        </div>
      </template>
    </dashboard-page>
    <div class="margin-ml">
      <riseup-button :title="backToCashflowButtonText" :action="backToCashflow" :size="'small'"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import BaseUI from '@riseupil/base-ui';
import router from '@/router';
import { BACKGROUND_POSITION } from '@riseupil/base-ui/src/utils/layout-consts';
import Property from '@/pages/responsive-pages/authenticated/navigation-pages/account-settings/Property.vue';
import Segment from '@/Segment';
import moment from 'moment';

export default {
  name: 'OneYearPromotionDone',
  components: {
    Property,
    RiseupButton: BaseUI.RiseupButton,
    DashboardPage: BaseUI.Pages.DashboardPage,
  },
  props: {
    paymentInfo: { type: Object, required: false, default: null },
  },
  async created() {
    await this.setAppHeaderProps({
      backgroundColorVariant: BaseUI.LayoutConsts.COLOR_VARIANT.BLUE,
      textColor: BaseUI.Colors.riseupWhite,
      logoColor: BaseUI.Colors.riseupWhite,
      sticky: false,
      rightActions: [],
    });
    // Load subscription data for nextPaymentDate and card info
    await this.fetchSubscription();

    Segment.trackUserGot('OneYearPromotionDoneEntered');
    Segment.trackUserGotToPixel('OneYearPromotionCompleted');
  },
  computed: {
    ...mapGetters('subscription', ['newFormattedCardNumberMask']),
    ...mapGetters('payment', ['formattedCardNumberMask']),
    ...mapState('session', ['activeMember']),
    ...mapState('subscription', ['nextPaymentDate']),
    displayCardMask() {
      if (this.paymentInfo && this.paymentInfo.cardMask) {
        return this.paymentInfo.cardMask;
      }
      return this.newFormattedCardNumberMask;
    },
    subscriptionTypeText() {
      return 'הרחבת מינוי שנתי במחיר מיוחד';
    },
    price() {
      return '430 ₪';
    },
    backToCashflowButtonText() {
      return 'חזרה לתזרים';
    },
    formattedStartDate() {
      if (this.nextPaymentDate) {
        return moment(this.nextPaymentDate).format('DD.MM.YYYY');
      }
      return moment().format('DD.MM.YYYY');
    },
    formattedEndDate() {
      if (this.nextPaymentDate) {
        return moment(this.nextPaymentDate).add(1, 'year').format('DD.MM.YYYY');
      }
      return moment().add(1, 'year').format('DD.MM.YYYY');
    },
    todayDate() {
      return moment().format('DD.MM.YYYY');
    },
    imageHeaderProps() {
      return {
        backgroundColor: BaseUI.LayoutConsts.COLOR_VARIANT.BLUE,
        bottomSeparator: false,
        textColor: BaseUI.LayoutConsts.COLOR_VARIANT.WHITE,
        backgroundPosition: BACKGROUND_POSITION.BOTTOM,
        imgHeight: 471,
      };
    },
  },
  methods: {
    ...mapActions('appHeader', ['setAppHeaderProps']),
    ...mapActions('subscription', ['fetchSubscription']),
    ...mapActions('subscriptionState', ['fetchSubscriptionState']),
    async backToCashflow() {
      Segment.trackUserInteraction('OneYearPromotionDone_BackToCashflowClicked');
      await this.fetchSubscriptionState();
      await this.$router.push({ path: '/home' });
    },
    redirectToPersonalInfo() {
      router.push({ path: '/personal-info' });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@riseupil/base-ui/src/scss/riseup-colors";
  .one-year-promotion-done {

    .headline-container {
      text-align: start;
      row-gap: 9px;
    }

    .header-animation-container {
      position: absolute;
      padding-top: 90px;
    }

    .success-lottie {
      height: 404px;
    }

    ::v-deep .title.with-overlay {
      align-items: unset;
    }

    .promotion-highlight {
      border-radius: 8px;
      background: var(--greens-00-c-070, #00C070);
      display: flex;
      padding: 5px 12px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      color: white;
      font-weight: bold;
      font-size: 12px;
      width: fit-content;
    }

    .link {
      cursor: pointer;
      text-decoration: underline;
      color: $riseup_blue;
    }

    .riseup-button {
      width: 100%;
      margin-top: 10px;
    }
  }
</style>
